/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_NewInputs */



/**
* | output |
* | --- |
* | "new" |
*
* @param {Usage_NewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_new = /** @type {((inputs?: Usage_NewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_NewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("nouveau")
	if (locale === "de") return /** @type {LocalizedString} */ ("neu")
	if (locale === "it") return /** @type {LocalizedString} */ ("nuovo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("новый")
	if (locale === "es") return /** @type {LocalizedString} */ ("nuevo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("novo")
	return /** @type {LocalizedString} */ ("new")
});